import {
  DELIVERY_ORDER_BATCHES_GET_BEGIN,
  DELIVERY_ORDER_BATCHES_GET_SUCCESS,
  DELIVERY_ORDER_BATCHES_GET_FAILURE, DELIVERY_ORDER_BATCH_REPLACE_SUCCESS,
} from './deliveryOrderBatchesActions';
import ITEM_TEMPERATURE from "../components/constants/itemTemperature";

const initialState = {
  deliveryOrderBatches: null,
  loading: false,
  error: null
};

export default function deliveryOrderBatchesReducer(state = initialState, action) {
  switch (action.type) {
    case DELIVERY_ORDER_BATCHES_GET_BEGIN:
      return {
        ...state,
        loading: true,
        error: null
      };
    case DELIVERY_ORDER_BATCHES_GET_SUCCESS:
      action.payload.deliveryOrderBatches.forEach(orderBatch => {
        orderBatch.orders.forEach(order => {
          order.items.sort((a, b) => {
            if (a.item.temperature === ITEM_TEMPERATURE.fruitVegetable.name ||
              a.item.temperature === ITEM_TEMPERATURE.fruitVegetableBox.name) {
              return -1;
            } else if (a.item.temperature === ITEM_TEMPERATURE.fridge.name
              && (b.item.temperature === ITEM_TEMPERATURE.room.name || !b.item.temperature)) {
              return -1;
            } else {
              return 1;
            }
          });
        });

        orderBatch.orders.sort((a) => {
          if (a.items.some(oi => oi.item.temperature === ITEM_TEMPERATURE.fruitVegetable.name)) {
            return -1;
          }
        });
      });

      action.payload.deliveryOrderBatches.sort((a) => {
        if (a.orders.some((o) => o.items.some(oi => oi.item.temperature === ITEM_TEMPERATURE.fruitVegetable.name))) {
          return -1;
        }
      });

      return {
        ...state,
        loading: false,
        deliveryOrderBatches: action.payload.deliveryOrderBatches,
      };
    case DELIVERY_ORDER_BATCH_REPLACE_SUCCESS:
      const existingIndex = state.deliveryOrderBatches.findIndex(dob => dob.id === action.payload.deliveryOrderBatch.id);
      const newOrderBatches = state.deliveryOrderBatches.slice();
      if (existingIndex >= 0) {
        newOrderBatches[existingIndex] = action.payload.deliveryOrderBatch;
      }

      return {
        ...state,
        deliveryOrderBatches: newOrderBatches,
      };
    case DELIVERY_ORDER_BATCHES_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        deliveryOrderBatches: null
      };
    default:
      return state;
  }
}